import React from 'react'
import { LoadingMaskRectangle } from './loading-mask-rectangle'

export function LoadingMaskSeverityBadge() {
  return (
    <LoadingMaskRectangle
      width={75}
      height={20}
      borderRadius={2}
      colorValue="lighter"
    />
  )
}
